import styled, { css } from 'styled-components';

export const inputMixin = css`
    box-sizing: border-box;
    height: 2em;
    min-width: 300px;
    width: calc(100% - 30px);
    padding-right: 1em;
    padding-left: 0.5em;
    border: 1px solid #bcbcbc;
    transition: border-color 150ms ease;
    outline: 0;
`;

const Input = styled.input`
    ${inputMixin};
`;

export default Input;
